import { Box, IconButton, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getMMMMYYYYFromString, getYYYYMFromString } from '../../shared/functions/dateProcessor';
interface MonthSelectorProps {
  disabled: boolean;
  currMonth: string;
  onMonthChange: (month: string) => void;
}

export default function MonthSelector(props: MonthSelectorProps) {
  const { disabled, currMonth, onMonthChange } = props;

  const handleClickNextMonth = () => {
    const nextMonth = getYYYYMFromString(currMonth, 1);
    onMonthChange(nextMonth);
  };

  const handleClickPrevMonth = () => {
    const prevMonth = getYYYYMFromString(currMonth, -1);
    onMonthChange(prevMonth);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <IconButton
        disabled={disabled}
        sx={{
          backgroundColor: '#F0F0F0',
          borderRadius: 1,
          padding: 0,
          '&:hover': {
            backgroundColor: '#DEDEDE',
          },
        }}
        size="small"
        onClick={() => handleClickPrevMonth()}
        data-cy="tracker-table-month-selector-prev-month"
      >
        <ChevronLeftIcon sx={{ color: '#525252', fontSize: 24 }} />
      </IconButton>
      <Box sx={{ width: '150px' }}>
        <Typography variant="h6">{disabled ? 'Filter View' : getMMMMYYYYFromString(currMonth)}</Typography>
      </Box>

      <IconButton
        disabled={disabled}
        sx={{
          backgroundColor: '#F0F0F0',
          borderRadius: 1,
          padding: 0,
          '&:hover': {
            backgroundColor: '#DEDEDE',
          },
        }}
        size="small"
        onClick={() => handleClickNextMonth()}
        data-cy="tracker-table-month-selector-next-month"
      >
        <ChevronRightIcon sx={{ color: '#525252', fontSize: 24 }} />
      </IconButton>
    </Box>
  );
}
